/* eslint-disable */
import { GetterTree } from "vuex";
import { Proposal } from "@/models/proposal";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ProposalState } from "@/types/proposal";

const getters: GetterTree<ProposalState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Proposal();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((proposal) => Proposal.toSelectItem(proposal))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((proposal) => {
          return proposal.id == id;
        })
      : new Proposal();
  },
};

export default getters;
